<template>
  <v-container class="fill-height pa-2" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card class="elevation-3" rounded="lg">
          <v-card-text class="pa-8 text-center">
            <!-- Loading State -->
            <div v-if="loading" class="mb-6">
              <v-progress-circular
                indeterminate
                color="primary"
                size="64"
              ></v-progress-circular>
              <p class="text-subtitle-1 mt-4">Processing your payment...</p>
            </div>

            <!-- Error State -->
            <div v-else-if="error" class="mb-6">
              <v-icon size="80" color="error">mdi-alert-circle</v-icon>
              <h1 class="text-h4 font-weight-medium mb-3 mt-4">Payment Processing Error</h1>
              <p class="text-subtitle-1 text--secondary mb-6">
                {{ error }}
              </p>
<!--              <v-btn-->
<!--                color="primary"-->
<!--                large-->
<!--                class="text-capitalize font-weight-medium"-->
<!--                to="/"-->
<!--              >-->
<!--                <v-icon left small>mdi-home</v-icon>-->
<!--                Return to Dashboard-->
<!--              </v-btn>-->
            </div>

            <!-- Success State -->
            <div v-else class="mb-6">
              <v-icon size="80" color="success">mdi-check-circle</v-icon>
              <h1 class="text-h4 font-weight-medium mb-3 mt-4">Payment Successful!</h1>
              <p class="text-subtitle-1 text--secondary mb-6">
                Your payment has been processed successfully.
              </p>

              <!-- Transaction Details -->
              <v-card outlined class="mb-6" v-if="apiResponse || transactionId">
                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="6" class="text-left">
                      <p class="text-subtitle-2 font-weight-medium mb-1">Transaction ID:</p>
                      <p class="text-body-1 mb-3">{{ transactionId || kazangTransactionId || 'N/A' }}</p>
                    </v-col>
                    <v-col cols="12" sm="6" class="text-left" v-if="amount">
                      <p class="text-subtitle-2 font-weight-medium mb-1">Amount:</p>
                      <p class="text-body-1 mb-3">{{ amount }}</p>
                    </v-col>
                    <v-col cols="12" class="text-left">
                      <p class="text-subtitle-2 font-weight-medium mb-1">Date & Time:</p>
                      <p class="text-body-1">{{ formattedDate }}</p>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- Action Buttons -->
<!--              <div class="d-flex flex-column flex-sm-row justify-center">-->
<!--                <v-btn-->
<!--                  color="primary"-->
<!--                  large-->
<!--                  class="text-capitalize font-weight-medium mr-sm-3 mb-3 mb-sm-0"-->
<!--                  to="/payments/create-link"-->
<!--                >-->
<!--                  <v-icon left small>mdi-link-variant</v-icon>-->
<!--                  Create Another Payment Link-->
<!--                </v-btn>-->
<!--                <v-btn-->
<!--                  color="secondary"-->
<!--                  large-->
<!--                  outlined-->
<!--                  class="text-capitalize font-weight-medium"-->
<!--                  to="/"-->
<!--                >-->
<!--                  <v-icon left small>mdi-home</v-icon>-->
<!--                  Go to Dashboard-->
<!--                </v-btn>-->
<!--              </div>-->

              <!-- Show Proof Button -->
              <div v-if="apiResponse && apiResponse.transactionId" class="text-center">
                <v-btn
                  color="primary"
                  large
                  class="text-capitalize font-weight-medium"
                  @click="showProof = true"
                >
                  <v-icon left small>mdi-receipt</v-icon>
                  Show Proof of Payment
                </v-btn>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Proof of Payment Dialog -->
    <ProofOfPaymentDialog
      v-if="apiResponse && apiResponse.transactionId"
      :show="showProof"
      :transaction-id="apiResponse.transactionId"
      @close="showProof = false"
    />
  </v-container>
</template>

<script>
import ProofOfPaymentDialog from '@/components/ProofOfPaymentDialog.vue';

export default {
  name: 'PaymentSuccess',
  components: {
    ProofOfPaymentDialog
  },
  data() {
    return {
      transactionId: this.$route.query.id || null,
      amount: this.$route.query.amount || null,
      timestamp: new Date(),
      reference_id: this.$route.query.ClientRef || null,
      cell: this.$route.query.Cell || null,
      kazangTransactionId: this.$route.query.KazangRef || null,
      network: this.$route.query.Network || null,
      apiResponse: null,
      loading: false,
      error: null,
      showProof: false
    };
  },
  computed: {
    formattedDate() {
      return this.timestamp.toLocaleString();
    }
  },
  mounted() {
    console.log('Payment success page loaded with transaction ID:', this.transactionId);
    console.log('URL parameters:', {
      id: this.transactionId,
      Cell: this.cell,
      Network: this.network,
      KazangRef: this.kazangTransactionId,
      ClientRef: this.reference_id
    });

    // Check if we have the required parameters
    if (this.reference_id && this.cell && this.kazangTransactionId) {
      this.submitPaymentData();
    } else {
      console.error('Missing required parameters for Kazang payment API call');
      this.error = 'Missing required parameters for payment processing';
    }
  },
  methods: {
    async submitPaymentData() {
      try {
        this.loading = true;
        this.error = null;

        // Prepare the payload
        const payload = {
          reference_id: this.reference_id,
          cell: this.cell,
          kazangTransactionId: this.kazangTransactionId,
          network: this.network,
          amount: parseFloat(this.amount) // Parse amount as number
        };

        console.log('Sending payload to API:', payload);

        // Make the API call
        const response = await fetch(`${pettyCashApi}api/kazang/payment/external/step2`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          throw new Error(`API call failed with status: ${response.status}`);
        }

        this.apiResponse = await response.json();
        console.log('Payment API response:', this.apiResponse);

      } catch (error) {
        console.error('Error submitting payment data:', error);
        this.error = 'Failed to process payment. Please try again or contact support.';
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
/* Responsive adjustments */
@media (max-width: 600px) {
  .pa-8 {
    padding: 24px !important;
  }

  .text-h4 {
    font-size: 1.5rem !important;
  }

  .v-icon.v-icon--dense {
    font-size: 64px !important;
  }
}
</style>
